"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "turtleDeviations", {
    enumerable: true,
    get: function() {
        return turtleDeviations;
    }
});
const turtleDeviations = [
    {
        deviationId: 140755035,
        typeId: 1,
        url: 'https://www.deviantart.com/chris/art/I-Like-Turtles-140755035',
        title: 'I Like Turtles',
        isJournal: false,
        isPurchasable: false,
        publishedTime: '2009-10-18T20:27:38-0700',
        isTextEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: true,
        blockReasons: [],
        author: {
            userId: 3,
            useridUuid: '178e6afa-0f9b-4ef0-bb15-47dadfa0e470',
            username: 'chris',
            usericon: 'https://a.deviantart.net/avatars-big/c/h/chris.jpg?4',
            type: 'admin',
            isNewDeviant: false
        },
        stats: {
            comments: 7,
            favourites: 19
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/178e6afa-0f9b-4ef0-bb15-47dadfa0e470/d2bsva3-bd1217db-4b15-4de3-83c0-4f67b5d7fc8a.jpg',
            prettyName: 'i_like_turtles_by_chris_d2bsva3',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzA3IiwicGF0aCI6IlwvZlwvMTc4ZTZhZmEtMGY5Yi00ZWYwLWJiMTUtNDdkYWRmYTBlNDcwXC9kMmJzdmEzLWJkMTIxN2RiLTRiMTUtNGRlMy04M2MwLTRmNjdiNWQ3ZmM4YS5qcGciLCJ3aWR0aCI6Ijw9MTA2MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.WUNdpBnjtdBUCIbSEvSR4RY709rVOgOADLrsKeHjCEU'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: 'v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
                    h: 100,
                    w: 150
                },
                {
                    t: '200H',
                    r: 0,
                    c: 'v1/fill/w_300,h_200,q_70,strp/<prettyName>-200h.jpg',
                    h: 200,
                    w: 300
                },
                {
                    t: '300W',
                    r: 0,
                    c: 'v1/fit/w_300,h_707,q_70,strp/<prettyName>-300w.jpg',
                    h: 200,
                    w: 300
                },
                {
                    t: '250T',
                    r: 0,
                    c: 'v1/fill/w_375,h_250,q_70,strp/<prettyName>-250t.jpg',
                    h: 250,
                    w: 375
                },
                {
                    t: '350T',
                    r: 0,
                    c: 'v1/fill/w_525,h_350,q_70,strp/<prettyName>-350t.jpg',
                    h: 350,
                    w: 525
                },
                {
                    t: '400T',
                    r: 0,
                    c: 'v1/fill/w_600,h_400,q_70,strp/<prettyName>-400t.jpg',
                    h: 400,
                    w: 600
                },
                {
                    t: 'preview',
                    r: 0,
                    c: 'v1/fill/w_1060,h_707,q_75,strp/<prettyName>-fullview.jpg',
                    h: 707,
                    w: 1060,
                    f: 3709669
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: 'v1/fill/w_1060,h_707,q_75,strp/<prettyName>-fullview.jpg',
                    h: 707,
                    w: 1060
                },
                {
                    t: 'fullview',
                    r: 0,
                    c: 'v1/fill/w_1060,h_707,q_75,strp/<prettyName>-fullview.jpg',
                    h: 707,
                    w: 1060,
                    f: 3709669
                }
            ]
        }
    },
    {
        deviationId: 1029514902,
        stashPrivateid: 7449809657977067,
        type: 'image',
        typeId: 1,
        url: 'https://www.deviantart.com/stash/021cqjb5z2ln',
        shortUrl: 'https://sta.sh/021cqjb5z2ln',
        title: 'Elephant',
        isJournal: false,
        isVideo: false,
        isPurchasable: false,
        isAdoptable: false,
        isFavouritable: false,
        publishedTime: '2024-03-08T23:02:57-0800',
        isTextEditable: false,
        isBackgroundEditable: false,
        legacyTextEditUrl: null,
        isShareable: true,
        isCommentable: true,
        isFavourited: false,
        isDeleted: false,
        isMature: false,
        isNsfg: false,
        isDownloadable: true,
        isAntisocial: false,
        isBlocked: false,
        isPublished: false,
        isDailyDeviation: false,
        hasPrivateComments: false,
        isDreamsofart: false,
        isAiUseDisallowed: true,
        isAiGenerated: false,
        canUpdateAiClaim: true,
        license: 'none',
        blockReasons: [],
        author: {
            userId: 75537591,
            useridUuid: '174972fe-0e51-4b4a-a088-72b4f5cb0d29',
            username: 'nlamay',
            usericon: 'https://a.deviantart.net/avatars-big/n/l/nlamay.jpg?6',
            type: 'admin',
            isGroup: false,
            isWatching: false,
            isSubscribed: false,
            isNewDeviant: false
        },
        stats: {
            comments: 0,
            favourites: 0,
            views: 1,
            downloads: 0,
            privatelyCollected: 0
        },
        media: {
            baseUri: 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/174972fe-0e51-4b4a-a088-72b4f5cb0d29/dh0y2s6-b92f5c17-82c5-4410-ad10-19f9bcadbdf7.png',
            prettyName: 'elephant_by_nlamay_dh0y2s6',
            token: [
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDAwIiwicGF0aCI6IlwvZlwvMTc0OTcyZmUtMGU1MS00YjRhLWEwODgtNzJiNGY1Y2IwZDI5XC9kaDB5MnM2LWI5MmY1YzE3LTgyYzUtNDQxMC1hZDEwLTE5ZjliY2FkYmRmNy5wbmciLCJ3aWR0aCI6Ijw9NDgwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.9BP0Ts4r5WQJoGnvD2Y1RTenGEj0bKQBTOGD4B154vI',
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzE3NDk3MmZlLTBlNTEtNGI0YS1hMDg4LTcyYjRmNWNiMGQyOVwvZGgweTJzNi1iOTJmNWMxNy04MmM1LTQ0MTAtYWQxMC0xOWY5YmNhZGJkZjcucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.CO1kRsjm2vTFxvwc1STTqkcVeuazJ9iKA8dMDQu91Eg'
            ],
            types: [
                {
                    t: '150',
                    r: 0,
                    c: '/v1/fit/w_150,h_150/<prettyName>-150.png',
                    h: 125,
                    w: 150,
                    o: true,
                    ss: [
                        {
                            x: 2,
                            c: '/v1/fit/w_300,h_300/<prettyName>-150-2x.png',
                            w: 300,
                            h: 300
                        }
                    ]
                },
                {
                    t: '200H',
                    r: 0,
                    c: '/v1/fill/w_240,h_200/<prettyName>-200h.png',
                    h: 200,
                    w: 240,
                    o: true,
                    ss: [
                        {
                            x: 2,
                            c: '/v1/fill/w_480,h_400/<prettyName>-200h-2x.png',
                            w: 480,
                            h: 400
                        }
                    ]
                },
                {
                    t: '300W',
                    r: 0,
                    c: '/v1/fit/w_300,h_400/<prettyName>-300w.png',
                    h: 250,
                    w: 300,
                    o: true,
                    ss: [
                        {
                            x: 2,
                            c: '/v1/fit/w_480,h_400/<prettyName>-300w-2x.png',
                            w: 480,
                            h: 400
                        }
                    ]
                },
                {
                    t: '375W',
                    r: 0,
                    c: '/v1/fit/w_375,h_313/<prettyName>-375w.png',
                    h: 313,
                    w: 375,
                    o: true,
                    ss: [
                        {
                            x: 2,
                            c: '/v1/fit/w_480,h_400/<prettyName>-375w-2x.png',
                            w: 480,
                            h: 400
                        }
                    ]
                },
                {
                    t: '414W',
                    r: 0,
                    c: '/v1/fit/w_414,h_345/<prettyName>-414w.png',
                    h: 345,
                    w: 414,
                    o: true,
                    ss: [
                        {
                            x: 2,
                            c: '/v1/fit/w_480,h_400/<prettyName>-414w-2x.png',
                            w: 480,
                            h: 400
                        }
                    ]
                },
                {
                    t: '250T',
                    r: 0,
                    c: '/v1/fill/w_300,h_250/<prettyName>-250t.png',
                    h: 250,
                    w: 300,
                    o: true,
                    ss: [
                        {
                            x: 2,
                            c: '/v1/fill/w_480,h_400/<prettyName>-250t-2x.png',
                            w: 480,
                            h: 400
                        }
                    ]
                },
                {
                    t: '350T',
                    r: 0,
                    c: '/v1/fill/w_420,h_350/<prettyName>-350t.png',
                    h: 350,
                    w: 420,
                    o: true,
                    ss: [
                        {
                            x: 2,
                            c: '/v1/fill/w_480,h_400/<prettyName>-350t-2x.png',
                            w: 480,
                            h: 400
                        }
                    ]
                },
                {
                    t: '400T',
                    r: 0,
                    c: '/v1/fill/w_480,h_400/<prettyName>-fullview.png',
                    h: 400,
                    w: 480,
                    o: true
                },
                {
                    t: 'preview',
                    r: 0,
                    c: '/v1/fill/w_480,h_400/<prettyName>-fullview.png',
                    h: 400,
                    w: 480,
                    o: true,
                    f: 379013
                },
                {
                    t: 'social_preview',
                    r: 0,
                    c: '/v1/fill/w_480,h_400/<prettyName>-fullview.png',
                    h: 400,
                    w: 480,
                    o: true
                },
                {
                    t: 'fullview',
                    r: 1,
                    h: 400,
                    w: 480,
                    o: true,
                    f: 379013
                },
                {
                    t: '92S',
                    r: 0,
                    c: '/v1/crop/w_92,h_92,x_5,y_0,scl_0.23/<prettyName>-92s.png',
                    h: 92,
                    w: 92,
                    o: true,
                    ss: [
                        {
                            x: 2,
                            c: '/v1/crop/w_184,h_184,x_9,y_0,scl_0.46/<prettyName>-92s-2x.png',
                            w: 184,
                            h: 184
                        }
                    ]
                },
                {
                    t: '125S',
                    r: 0,
                    c: '/v1/crop/w_125,h_125,x_6,y_0,scl_0.3125/<prettyName>-125s.png',
                    h: 125,
                    w: 125,
                    o: true,
                    ss: [
                        {
                            x: 2,
                            c: '/v1/crop/w_250,h_250,x_13,y_0,scl_0.625/<prettyName>-125s-2x.png',
                            w: 250,
                            h: 250
                        }
                    ]
                }
            ]
        },
        extended: {
            deviationUuid: '2032B2E6-21FA-C070-51BA-3EF4DF692E3E',
            canUserAddToGroup: true,
            isDaProtected: true,
            groupListUrl: 'https://www.deviantart.com/deviation/1029514902/groups',
            originalFile: {
                type: 'png',
                width: 480,
                height: 400,
                filesize: 379013
            },
            download: {
                url: 'https://www.deviantart.com/download/7449809657977067/dh0y2s6-b92f5c17-82c5-4410-ad10-19f9bcadbdf7.png?token=419d51be918292b7c35dbe86c06fe20bc52b64ad&ts=1709970075',
                type: 'png',
                width: 480,
                height: 400,
                filesize: 379013
            },
            stats: {
                views: 1,
                today: 1,
                shares: 0,
                downloads: 0,
                groups: 0
            },
            showStageMonetizationPromo: 'generic',
            descriptionText: {
                excerpt: '',
                html: {
                    type: 'writer',
                    markup: '',
                    features: '[{"type":"WORD_COUNT_FEATURE","data":{"words":0,"chars":0}}]'
                }
            }
        }
    }
];
